import { render, staticRenderFns } from "./CartMain.vue?vue&type=template&id=d2f12f48&"
import script from "./CartMain.vue?vue&type=script&lang=js&"
export * from "./CartMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports